// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '49a7d1b',
    builtAt: '2026-09-09T14:35:40.618Z',
} as const;
